import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mobile", "menuIcon", "brandText"]

  connect() {
    this.solidClasses = ["bg-white/95", "shadow-md", "ring-1", "ring-slate-200/60", "backdrop-blur"]
    this.scroll = this.scroll.bind(this)
    this.scroll()
    window.addEventListener("scroll", this.scroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this.scroll)
  }

  scroll() {
    const solid = window.scrollY > 40
    this.solidClasses.forEach(c => this.element.classList.toggle(c, solid))
    this.element.classList.toggle("text-ink-900", solid)
    this.element.classList.toggle("text-white", !solid)
  }

  toggle() {
    if (!this.hasMobileTarget) return
    const isOpen = this.mobileTarget.style.maxHeight && this.mobileTarget.style.maxHeight !== "0px"
    if (isOpen) this.close()
    else this.mobileTarget.style.maxHeight = this.mobileTarget.scrollHeight + "px"
  }

  close() {
    if (this.hasMobileTarget) this.mobileTarget.style.maxHeight = "0px"
  }
}
